import { gql } from '@apollo/client'
import { Page, ThankYouPage } from 'components/organisms'
import { initializeApollo } from 'gql/client'
import { useTrans } from 'hooks'
import { Button } from 'components/atoms'
import { PAGINA } from 'utils/queries'
import { NextWrapper } from 'data-fetching-wrapper'

function CheckoutError({ pagina }) {
  const t = useTrans()

  return (
    <Page 
      hideHead 
      hidePrefooter
      headerType='minimal'
      footerType='none'
      pagina={pagina} 
      backButton={{
        labelMobile: t("Carrello"),
        href: '/carrello'
      }}
      className="thank-you-page-template"
    >
      <ThankYouPage 
        imageUrl=""
        title={t("Errore nel pagamento")}
        buttons={[<Button label={t("Torna alla home")} href="/" />]}
        className="thank-you-page-template"
      />
    </Page>
  )
}


export const getStaticProps = NextWrapper.getStaticProps(async ({ locale }) => {
  const client = initializeApollo(null,null,null,locale)

  const {
    data: { pagina },
  } = await client.query({
    query: gql`
      ${PAGINA.replace('__chiave__', "checkout-error")}
    `,
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  return {
    props: { pagina },
    revalidate: 60 * 5,
  }
}, '/carrello/checkout/error/')

export default CheckoutError
